import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPathwaySelectionsState } from '@ispm-client/modules/pathway-selections/store/reducers/pathway-selections.reducer';

export const getPathwaysListState = (state: IPathwaySelectionsState) => state.history;
export const getTPNoteState = (state: IPathwaySelectionsState) => state.tpNote;

export const selectPathwaySelectionsState = createFeatureSelector<IPathwaySelectionsState>('pathwaySelections');
export const selectPathwaysListState = createSelector(
  selectPathwaySelectionsState,
  getPathwaysListState
);
export const selectTPNoteState = createSelector(
  selectPathwaySelectionsState,
  getTPNoteState
);
